// extracted by mini-css-extract-plugin
module.exports = {"container":"Reactions_container__LJ49i","count":"Reactions_count__SwTv_","counts":"Reactions_counts__wu_qq"};